
import { ACTIVIT_REPORTS } from "../constant/ActionType";

export default function AllReducerActivityReport(
    state = {
        alldataactnote: [],
    },
    action
) {
    switch (action.type) {
        case ACTIVIT_REPORTS:
            return {
                ...state,
                alldataactnote: action.data,
            };
        default:
    }
    return state;
}
